import aiAgentDarkAvatar from '@ui/icons/sona/Sona_dark.svg?url'
import aiAgentLightAvatar from '@ui/icons/sona/Sona_light.svg?url'

const aiAgentConstants = {
  id: 'ai-agent',
  name: 'Sona',
  price: 4900,
  darkAvatar: aiAgentDarkAvatar,
  lightAvatar: aiAgentLightAvatar,
  routeName: 'sona',
  aiAgentDemoPhoneNumber: '(866) 587-7662',
  knowledgeBestPracticesGuideUrl:
    'https://support.openphone.com/hc/en-us/articles/31257696720023',
  pricingUrl:
    'https://support.openphone.com/hc/en-us/articles/31238891901079-Sona-AI-Agent-pricing',
  agentLaunchVideoUrl: 'https://play.vidyard.com/AdjoLiJ4k15uKfcghhmWhn',
} as const

export default aiAgentConstants
